import Typography from '@mui/material/Typography';

// import SearchLogInput from './SearchLogInput';
import ClearFiltersButon from './ClearFiltersButon';
import RefreshLogButton from './RefreshLogButton';
import FilterLogButton from './FilterLogButton';
import LogFilterContent from './LogFilterContent';
import { useAreFiltersApplied, useSelectedLogNameItem } from 'hooks/useOrganizationLoggingHook';

const LoggingContentHeader = () => {
    const selectedLogNameItem = useSelectedLogNameItem();
    const areFiltersApplied = useAreFiltersApplied();

    return (
        <>
            <div className="logContentHeader">
                <Typography className="logContentHeaderTitle" component="h4">
                    {selectedLogNameItem.header} Logs
                </Typography>
                <div className="logContentHeaderSearchBar">
                    {areFiltersApplied ? <ClearFiltersButon /> : null}
                    {/* <SearchLogInput /> */}
                    <RefreshLogButton logType={selectedLogNameItem} />
                    <FilterLogButton />
                </div>
            </div>
            <LogFilterContent />
        </>
    );
};

export default LoggingContentHeader;
